<template lang="pug">
v-container(fluid='')
  v-card
    v-card-title.d-flex.justify-space-between
      span Gesti&oacute;n de Pagos
      v-btn(color="primary" class="mr-2" @click="openPaymentDialog()")
          v-icon(left) mdi-cash-multiple
          | Pago a Proveedor
      v-btn(color='primary', @click='openDialog()')
        v-icon(left='') mdi-plus
        |  Nuevo pago no planificado
    v-card-text
      // Filters
      v-row.mb-4
        v-col(cols='12', sm='4')
          v-menu(ref='dateMenu', v-model='dateMenu', :close-on-content-click='false', transition='scale-transition', offset-y='', max-width='290px', min-width='auto')
            template(v-slot:activator='{ on, attrs }')
              v-text-field(v-model='dateFilter', label='Filtrar por fecha', prepend-icon='mdi-calendar', readonly='', v-bind='attrs', v-on='on', clearable='', @click:clear='dateFilter = null')
            v-date-picker(v-model='dateFilter', no-title='', @input='dateMenu = false')
        v-col(cols='12', sm='4')
          v-select(v-model='categoryFilter', :items='categories', label='Categoría', clearable='', prepend-icon='mdi-filter-variant')
        v-col(cols='12', sm='4')
          v-text-field(v-model='search', label='Buscar', prepend-icon='mdi-magnify', clearable='')
      // Expenses Table
      v-data-table(:headers='headers', :items='filteredExpenses', :loading='loading', :search='search')
        template(v-slot:item.date='{ item }')
          | {{ formatDate(item.date) }}
        template(v-slot:item.amount='{ item }')
            | ${{ item.amount }}
        template(v-slot:item.category='{ item }')
              v-chip(small='') {{ item.category }}
        template(v-slot:item.hasinvoice='{ item }')
                v-icon(:color="item.hasInvoice ? 'success' : 'grey'")
                  | {{ item.hasInvoice ? &apos;mdi-check&apos; : &apos;mdi-close&apos; }}
        template(v-slot:item.actions='{ item }')
                  v-btn.mr-2(icon='', small='', @click='openDialog(item)')
                    v-icon mdi-pencil
                  v-btn(icon='', small='', @click='viewExpense(item)')
                    v-icon mdi-eye
      // Expense Form Dialog
      v-dialog(v-model='dialog', max-width='600')
        v-card
          v-card-title
            | {{ editedItem._id ? &apos;Editar&apos; : &apos;Nuevo&apos; }} Gasto
          v-card-text
            v-form(ref='form', v-model='valid')
              v-menu(ref='editDateMenu', v-model='editDateMenu', :close-on-content-click='false', transition='scale-transition', offset-y='', min-width='auto')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(:value='formattedEditDate', label='Fecha', readonly='', v-bind='attrs', v-on='on', :rules="[v => !!v || 'La fecha es requerida']", required='')
                v-date-picker(v-model='editedItem.date', @input='editDateMenu = false', locale='es')
              v-text-field(v-model='editedItem.description', label='Descripción', :rules="[v => !!v || 'La descripción es requerida']", required='')
              v-text-field(v-model.number='editedItem.amount', label='Monto', type='number', prefix='$', :rules="[\
              v => !!v || 'El monto es requerido',\
              v => v > 0 || 'El monto debe ser mayor a 0'\
              ]", required='')
              v-select(v-model='editedItem.category', :items='categories', label='Categoría', :rules="[v => !!v || 'La categoría es requerida']", required='')
              v-switch(v-model='editedItem.hasInvoice', label='Tiene factura/comprobante', color='success')
              v-expand-transition
                div(v-if='editedItem.hasInvoice')
                  v-text-field(v-model='editedItem.invoiceNumber', label='Número de factura', :rules="[v => !!v || 'El número de factura es requerido']", required='')
                  v-file-input(v-model='invoiceFile', label='Adjuntar comprobante', accept='image/*,.pdf', prepend-icon='mdi-paperclip', :rules="[v => !editedItem.hasInvoice || !!v || 'El comprobante es requerido']", required='')
              v-textarea(v-model='editedItem.notes', label='Notas adicionales', rows='3')
          v-card-actions
            v-spacer
            v-btn(text='', @click='closeDialog')  Cancelar
            v-btn(color='primary', :disabled='!valid', @click='save')  Guardar
      // Supplier Payment Dialog
      v-dialog(v-model="paymentDialog" max-width="1200")
        v-card
          v-card-title Pago a Proveedor
          v-card-text
            v-form(ref="paymentForm" v-model="paymentValid")
              v-row
                // Supplier Selection
                v-col(cols="6")
                  v-autocomplete(v-model="payment.supplier" :items="suppliers"  item-text="businessName" item-value="_id" label="Proveedor" :rules="[v => !!v || 'Selecciona un proveedor']" required @change="loadPendingInvoices")
                // Payment Date
                v-col(cols="6" sm="6")
                  v-menu(
                    ref="paymentDateMenu"
                    v-model="paymentDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  )
                    template(v-slot:activator="{ on, attrs }")
                      v-text-field(
                        v-model="payment.date"
                        label="Fecha de pago"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[v => !!v || 'La fecha es requerida']"
                        required
                      )
                    v-date-picker(
                      v-model="payment.date"
                      @input="paymentDateMenu = false"
                    )

              // Pending Invoices
              v-card(outlined class="mt-4" v-if="pendingInvoices.length")
                v-card-title Facturas Pendientes
                v-card-text
                  v-data-table(
                    v-model="payment.selectedInvoices"
                    :headers="invoiceHeaders"
                    :items="pendingInvoices"
                    show-select
                    item-key="_id"
                    @input="updateTotalAmount"
                  )
                    template(v-slot:item.date="{ item }")
                      | {{ formatDate(item.date) }}
                    template(v-slot:item.total="{ item }")
                      | ${{ item.total?.toFixed(2) }}
                    template(v-slot:item.remainingAmount="{ item }")
                      | ${{ item.paymentStatus === 'PARTIALLY_PAID' ? item.remainingAmount?.toFixed(2) : item.total }}
                    template(v-slot:item.paymentStatus="{ item }")
                      v-chip(
                        small
                        :color="getPaymentStatusColor(item.paymentStatus)"
                      ) {{ getPaymentStatusText(item.paymentStatus) }}
              v-row
                v-col(cols="6")
                  // Payment Amount Input
                  v-card(outlined class="mt-4")
                    v-card-text
                      v-text-field(
                        v-model.number="paymentAmount"
                        label="Monto total a pagar"
                        type="number"
                        prefix="$"
                        :rules="[v => !!v || 'El monto es requerido', v => v > 0 || 'El monto debe ser mayor a 0', v => v <= totalSelectedInvoices || 'El monto no puede superar el total pendiente']"
                        required
                        @input="distributePaymentAmount")
                v-col(cols="6")
                  // Payment Methods
                  v-card(outlined class="mt-4")
                    v-card-title Formas de Pago
                    v-card-text
                      v-row
                        v-col(cols="12")
                          v-select(
                            v-model="payment.methods"
                            :items="paymentMethods"
                            item-text="text"
                            item-value="value"
                            label="Formas de pago"
                            multiple
                            chips
                            small-chips
                            :rules="[v => v.length > 0 || 'Selecciona al menos una forma de pago']"
                            required
                          )

                      // Amount per payment method
                      template(v-if="payment.methods.length")
                        v-row(v-for="method in payment.methods" :key="method")
                          v-col(cols="12")
                            v-text-field(
                              v-model.number="payment.amounts[method]"
                              :label="`Monto ${getPaymentMethodLabel(method)}`"
                              type="number"
                              prefix="$"
                              :rules="amountRules"
                              required
                              @input="validatePaymentAmounts"
                            )
              // Totals
              v-card(outlined class="mt-4")
                v-card-text
                  v-row
                    v-col(cols="12" sm="4")
                      .subtitle-1 Total Facturas Seleccionadas
                      .text-h5 ${{ totalSelectedInvoices?.toFixed(2) }}
                    v-col(cols="12" sm="4")
                      .subtitle-1 Monto a Pagar
                      .text-h5 ${{ paymentAmount?.toFixed(2) }}
                    v-col(cols="12" sm="4")
                      .subtitle-1 Total Formas de Pago
                      .text-h5(:class="{'error--text': !isPaymentValid}")
                        | ${{ totalPaymentMethods?.toFixed(2) }}
          v-card-actions
            v-spacer
            v-btn(text @click="closePaymentDialog") Cancelar
            v-btn(
              color="primary"
              :disabled="!paymentValid || !isPaymentValid"
              @click="processPayment"
            ) Procesar Pago
      // Expense Detail Dialog
      v-dialog(v-model='detailDialog', max-width='600')
        v-card(v-if='selectedExpense')
          v-card-title
            | Detalle del Gasto
            v-spacer
            v-chip(small='') {{ selectedExpense.category }}
          v-card-text
            v-list(dense='')
              v-list-item
                v-list-item-content
                  v-list-item-title Fecha
                  v-list-item-subtitle
                    | {{ formatDate(selectedExpense.date) }}
              v-list-item
                v-list-item-content
                  v-list-item-title Descripci&oacute;n
                  v-list-item-subtitle
                    | {{ selectedExpense.description }}
              v-list-item
                v-list-item-content
                  v-list-item-title Monto
                  v-list-item-subtitle
                    | ${{ selectedExpense.amount?.toFixed(2) }}
              template(v-if='selectedExpense.hasInvoice')
                v-list-item
                  v-list-item-content
                    v-list-item-title N&uacute;mero de Factura
                    v-list-item-subtitle
                      | {{ selectedExpense.invoiceNumber }}
                v-list-item(v-if='selectedExpense.invoiceUrl')
                  v-list-item-content
                    v-list-item-title Comprobante
                    v-list-item-subtitle
                      v-btn(text='', small='', color='primary', :href='selectedExpense.invoiceUrl', target='_blank')
                        v-icon(left='', small='') mdi-download
                        |  Descargar
                v-list-item(v-if='selectedExpense.notes')
                  v-list-item-content
                    v-list-item-title Notas
                    v-list-item-subtitle
                      | {{ selectedExpense.notes }}
          v-card-actions
            v-spacer
            v-btn(text='', @click='detailDialog = false')  Cerrar
            v-btn(color='primary', @click='printExpense')  Imprimir
</template>
<script>
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { mapState } from 'vuex'

export default {
  name: 'ExpensesView',

  data: () => ({
    loading: false,
    dialog: false,
    detailDialog: false,
    dateMenu: false,
    editDateMenu: false,
    valid: false,
    search: '',
    dateFilter: null,
    categoryFilter: null,
    invoiceFile: null,
    paymentDialog: false,
    paymentValid: false,
    paymentDateMenu: false,
    paymentAmount: 0, // Nuevo campo para el monto total a pagar
    payment: {
      supplier: null,
      date: new Date().toISOString().substr(0, 10),
      selectedInvoices: [],
      methods: [],
      amounts: {}
    },
    pendingInvoices: [],
    invoiceHeaders: [
      { text: 'Número', value: 'number' },
      { text: 'Fecha', value: 'date' },
      { text: 'Monto', value: 'total' },
      { text: 'Estado', value: 'paymentStatus' },
      { text: 'Pendiente', value: 'remainingAmount' }
    ],
    paymentMethods: [
      { text: 'Efectivo', value: 'cash' },
      { text: 'Transferencia', value: 'transfer' },
      { text: 'Cheque', value: 'check' }
    ],
    amountRules: [
      v => !!v || 'El monto es requerido',
      v => v > 0 || 'El monto debe ser mayor a 0'
    ],
    headers: [
      { text: 'Fecha', value: 'date' },
      { text: 'Descripción', value: 'description' },
      { text: 'Categoría', value: 'category' },
      { text: 'Monto', value: 'amount' },
      { text: 'Comprobante', value: 'hasInvoice', align: 'center' },
      { text: 'Acciones', value: 'actions', sortable: false }
    ],
    categories: [
      'Mantenimiento',
      'Servicios',
      'Insumos',
      'Limpieza',
      'Marketing',
      'Impuestos',
      'Seguros',
      'Otros'
    ],
    editedItem: {
      date: new Date().toISOString().substr(0, 10),
      description: '',
      amount: 0,
      category: '',
      hasInvoice: false,
      invoiceNumber: '',
      notes: ''
    },
    defaultItem: {
      date: new Date().toISOString().substr(0, 10),
      description: '',
      amount: 0,
      category: '',
      hasInvoice: false,
      invoiceNumber: '',
      notes: ''
    },
    selectedExpense: null
  }),

  computed: {
    ...mapState({
      suppliers: state => state.suppliers.list,
      expenses: state => state.expenses.list
    }),
    totalInvoices() {
      return this.payment.selectedInvoices.reduce((sum, invoice) => 
        sum + invoice.total, 0
      )
    },
    totalSelectedInvoices() {
      this.payment.selectedInvoices.forEach(invoice => {
        if (invoice.paymentStatus === 'UNPAID') {
          invoice.remainingAmount = invoice.total
        }
      })
      return this.payment.selectedInvoices.reduce((sum, invoice) => 
        sum + invoice.remainingAmount, 0
      );
    },
    totalPaymentMethods() {
      return Object.values(this.payment.amounts).reduce((sum, amount) => 
        sum + (Number(amount) || 0), 0
      )
    },

    isPaymentValid() {
      return Math.abs(this.totalPaymentMethods - this.paymentAmount) < 0.01;
    },
    filteredExpenses() {
      let filtered = [...this.expenses]

      if (this.dateFilter) {
        filtered = filtered.filter(expense =>
          expense.date.startsWith(this.dateFilter)
        )
      }

      if (this.categoryFilter) {
        filtered = filtered.filter(expense =>
          expense.category === this.categoryFilter
        )
      }

      return filtered
    },

    formattedEditDate() {
      if (!this.editedItem.date) return ''
      return this.formatDate(this.editedItem.date)
    }
  },

  methods: {
    getPaymentStatusColor(status) {
      return {
        'PAID': 'success',
        'PARTIALLY_PAID': 'warning',
        'UNPAID': 'error'
      }[status] || 'grey';
    },

    getPaymentStatusText(status) {
      return {
        'PAID': 'Pagado',
        'PARTIALLY_PAID': 'Pago Parcial',
        'UNPAID': 'Impaga'
      }[status] || status;
    },

    distributePaymentAmount() {
      // Reset payment methods and amounts
      this.payment.methods = [];
      this.payment.amounts = {};
      
      if (this.paymentAmount <= 0) return;

      // Por defecto asignar todo a efectivo
      this.payment.methods = ['cash'];
      this.payment.amounts = {
        cash: this.paymentAmount
      };
    },

    validatePaymentAmounts() {
      const total = this.totalPaymentMethods;
      if (total > this.paymentAmount) {
        // Reset el último método agregado
        const lastMethod = this.payment.methods[this.payment.methods.length - 1];
        this.payment.amounts[lastMethod] = 0;
      }
    },

    async processPayment() {
      if (!this.$refs.paymentForm.validate()) return;
      if (!this.isPaymentValid) return;

      try {
        await this.$store.dispatch('supplierAccount/addPayment', {
          supplier: this.payment.supplier,
          date: this.payment.date,
          invoices: this.payment.selectedInvoices.map(i => i._id),
          payments: Object.entries(this.payment.amounts)
            .filter(([_, amount]) => amount > 0)
            .map(([method, amount]) => ({
              method,
              amount: Number(amount)
            }))
        });

        this.$toast.success('Pago procesado correctamente');
        this.closePaymentDialog();
        this.loadPendingInvoices();
      } catch (error) {
        this.$toast.error('Error al procesar el pago');
      }
    },

    closePaymentDialog() {
      this.paymentDialog = false;
      this.payment = {
        supplier: null,
        date: new Date().toISOString().substr(0, 10),
        selectedInvoices: [],
        methods: [],
        amounts: {}
      };
      this.paymentAmount = 0;
      this.pendingInvoices = [];
      this.$refs.paymentForm?.reset();
    },
    formatDate(date) {
      // Para fechas en formato YYYY-MM-DD del datepicker, crear fecha local sin conversión de zona horaria
      if (typeof date === 'string' && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = date.split('-').map(Number)
        const localDate = new Date(year, month - 1, day) // month es 0-indexed
        return format(localDate, 'dd/MM/yyyy', { locale: es })
      }
      // Para otras fechas (con tiempo), usar el método normal
      return format(new Date(date), 'dd/MM/yyyy', { locale: es })
    },

    openDialog(item = null) {
      this.editedItem = item ? { ...item } : { ...this.defaultItem }
      this.dialog = true
    },

    closeDialog() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.invoiceFile = null
        this.$refs.form.reset()
      })
    },

    async save() {
      if (!this.$refs.form.validate()) return

      const formData = new FormData()
      Object.keys(this.editedItem).forEach(key => {
        formData.append(key, this.editedItem[key])
      })

      if (this.invoiceFile) {
        formData.append('invoice', this.invoiceFile)
      }

      try {
        if (this.editedItem._id) {
          await this.$store.dispatch('expenses/update', formData)
          this.$toast.success('Gasto actualizado')
        } else {
          await this.$store.dispatch('expenses/create', formData)
          this.$toast.success('Gasto registrado')
        }
        this.closeDialog()
      } catch (error) {
        this.$toast.error('Error al guardar el gasto')
      }
    },

    viewExpense(expense) {
      this.selectedExpense = expense
      this.detailDialog = true
    },

    printExpense() {
      // Implement print functionality
    },

    openPaymentDialog() {
      this.payment = {
        supplier: null,
        date: new Date().toISOString().substr(0, 10),
        selectedInvoices: [],
        methods: [],
        amounts: {}
      }
      this.paymentDialog = true
    },
    async loadPendingInvoices() {
      if (!this.payment.supplier) return;

      try {
        const { data } = await this.$http.get(
          `/suppliers/${this.payment.supplier}/pending-invoices`
        );
        this.pendingInvoices = data.filter(e => e.paymentStatus !== 'PAID');
      } catch (error) {
        this.$toast.error('Error al cargar facturas pendientes');
      }
    },

    updateTotalAmount() {
      // Reset payment amounts when invoices change
      this.payment.amounts = {};
      this.payment.methods = [];
    },

    validateTotalAmount() {
      // Validate as user types amounts
      if (this.totalPaymentMethods > this.totalSelectedInvoices) {
        // Reset the last changed amount
        const lastMethod = this.payment.methods[this.payment.methods.length - 1];
        this.payment.amounts[lastMethod] = 0;
      }
    },

    getPaymentMethodLabel(method) {
      const found = this.paymentMethods.find(m => m.value === method);
      return found ? found.text : method;
    },
  },
  
  async created() {
    this.loading = true
    try {
      await this.$store.dispatch('expenses/fetch')
      await this.$store.dispatch('suppliers/fetch')
    } catch (error) {
      this.$toast.error('Error al cargar los gastos')
    } finally {
      this.loading = false
    }
  }
}
</script>
